<template>
    <div class="main-content">
        <h4>Verify New Users</h4>
        <p class="diagonal-lines"></p>

        <div v-if="loading">
            <div class="vh-100 d-flex justify-content-center align-items-center">
            <vue-loaders-ball-beat scale="2" color="black" />
            </div>
        </div>
        <div v-else>
            <div v-if="userUpdate" class="my-2">
                <div v-if="userUpdate.approved=='y'">
                    <success>{{ userUpdate.f_name }} {{ userUpdate.l_name }} has been authorized to access distributor tools.</success>
                </div>
                <div v-else>
                    <success>{{ userUpdate.f_name }} {{ userUpdate.l_name }} has been archived.</success>
                </div>
            </div>
            <div class="new-user-list" v-if="newUserList.length != 0">

                <section class="new-user " v-for="(user,index) in newUserList" :key="index">
                    <form class="d-flex flex-column justify-content-start align-items-start">
                        <router-link class="user-name" :to="{ name: 'myAccount' }">
                            {{ user.f_name }} {{ user.l_name }}
                        </router-link>
                        <span>{{ user.timestamp }}</span>
                        <p><strong>COMPANY: </strong><span>{{ user.company }}</span></p>
                        <p><strong>TITLE: </strong><span>{{ user.title }}</span></p>
                        <p><strong>ADDRESS: </strong><span>{{ user.add1 }} {{ user.add2 }} {{ user.city }},{{ user.state }},{{ user.zip }}</span></p>
                        <p><strong>PHONE: </strong><span>{{ user.phone }}</span></p>
                        <p><strong>EMAIL: </strong><span>{{ user.email }}</span></p>

                        <div class="mt-3">
                            <b-form-group label="ADMIN APPROVAL:" v-slot="{ ariaDescribedby }"  >
                                <b-form-radio-group
                                    v-model="userForm[index].approve"
                                    :aria-describedby="ariaDescribedby"
                                    :name="'approve_'+index"
                                >
                                <b-form-radio  value="y"  @change="onChangeAdminApprove(index,'y')">Yes</b-form-radio>
                                <b-form-radio  value="n"  @change="onChangeAdminApprove(index,'n')">No</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>

                        <div class="mb-3 w-100" v-if="showUserType[index]==='y'" >
                            <legend>USER TYPE:</legend>
                            <select :name="'userGroup_'+index" v-model="userForm[index].selectedUserGroup" @change="onSelectedUserGroup(index,$event)">
                                <option v-for="(group,index) in userGroup" :key="index" :value=group.id>{{ group.user_group }}</option>
                            </select>
                        </div>

                        <div class="mb-3 w-100" v-if="userGroupSelected[index]=='3' && showUserType[index]==='y'" >
                            <legend>CUSTOMER BILL-TO:</legend>
                            <input type="number" :name="'custID_'+index" class="w-100" v-model="userForm[index].custID">
                        </div>

                        <button class="btn-round-red" type="submit" @click.prevent="verifyUser(index)" >SUBMIT</button>

                    </form>
                </section>


            </div>
            <div class="my-3" v-else>
                <strong>NO NEW USER HAS SIGN UP.</strong>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            userGroup:[],
            newUserList:[],
            userForm:[],
            showUserType:[],
            userGroupSelected:[],
            error:null,
            userUpdate:null
        };
    },

    created() {

    },
    mounted() {
        this.loading=true;
        // get user group
        axios.get(`/api/usergroup/`)
        .then(response => {
            this.userGroup = response.data;
        })
        .catch(error => {
            this.error=error;
        });

        axios.get(`/api/user/new/`)
        .then(response => {

            this.newUserList = response.data;

            for(let i=0; i<=this.newUserList.length; i++){
                if (response.data[i] && response.data[i].id) {
                    this.userForm[i] = {
                    'userID': response.data[i].id,
                    'custID': '',
                    'approve': '',
                    'selectedUserGroup': '2'
                    };
                }
            }
            this.loading=false;

        })
        .catch(error => {
            this.error=error;
        });

    },

    methods:{
        onChangeAdminApprove(index,value){
            this.$set(this.showUserType, index, value);
        },
        onSelectedUserGroup(index,e){
            this.$set(this.userGroupSelected, index, e.target.value);
        },
        verifyUser(index){
            this.loading=true;

            axios.post(`/api/userApprove`, this.userForm[index]).then(response=>{
                this.userUpdate=response.data.user;

                //get ID of the user which was just updated
                let updatedUserID=response.data.user.id;


                //remove the approved user from the array
                this.newUserList=this.newUserList.filter(function (user) {
                    return parseInt(user.id) !== parseInt(updatedUserID);
                });

                this.showUserType=[];
                this.userGroupSelected=[];

                //update userForm model
                for(let i=0; i<=this.newUserList.length; i++){
                    if (this.newUserList[i] && this.newUserList[i].id) {
                        this.userForm[i] = {
                        'userID': this.newUserList[i].id,
                        'custID': '',
                        'approve': '',
                        'selectedUserGroup': '2'
                        };
                    }
                }
                window.scrollTo(0,0);
                this.loading=false;


            }).catch(error => {
                this.loading=false;
                console.log(error);
                this.error=error;
            });
        },
    },

}
</script>
